import { ActionTypes, LoadBalancerAllocationActions } from './load-balancer-allocations.actions';
import { LoadBalancerAllocationState } from './load-balancer-allocations.model';

export const loadBalancerAllocationState: LoadBalancerAllocationState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getLoadBalancerAllocationLoading: false,
  getLoadBalancerAllocationLoaded: false,
  loadBalancerAllocation: null,
  addLoadBalancerAllocationLoading: false,
  addLoadBalancerAllocationLoaded: false,
  editLoadBalancerAllocationLoading: false,
  editLoadBalancerAllocationLoaded: false,
  deleteLoadBalancerAllocationsLoading: false,
  deleteLoadBalancerAllocationsLoaded: false,
  channelsDataLoading: false,
  channelsDataLoaded: false,
  channelsData: [],
};

export function loadBalancerAllocationReducer(
  state: LoadBalancerAllocationState = loadBalancerAllocationState,
  action: LoadBalancerAllocationActions,
): LoadBalancerAllocationState {
  switch (action.type) {
    case ActionTypes.LOAD_BALANCER_ALLOCATIONS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.LOAD_BALANCER_ALLOCATIONS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_LOAD_BALANCER_ALLOCATION:
      return {
        ...state,
        getLoadBalancerAllocationLoading: true,
        getLoadBalancerAllocationLoaded: false,
      };
    case ActionTypes.GET_LOAD_BALANCER_ALLOCATION_COMPLETED:
      return {
        ...state,
        loadBalancerAllocation: action.payload.data,
        getLoadBalancerAllocationLoading: false,
        getLoadBalancerAllocationLoaded: true,
      };
    case ActionTypes.ADD_LOAD_BALANCER_ALLOCATION:
      return {
        ...state,
        addLoadBalancerAllocationLoading: true,
        addLoadBalancerAllocationLoaded: false,
      };
    case ActionTypes.ADD_LOAD_BALANCER_ALLOCATION_COMPLETED:
      return {
        ...state,
        addLoadBalancerAllocationLoading: false,
        addLoadBalancerAllocationLoaded: true,
      };
    case ActionTypes.EDIT_LOAD_BALANCER_ALLOCATION:
      return {
        ...state,
        editLoadBalancerAllocationLoading: true,
        editLoadBalancerAllocationLoaded: false,
      };
    case ActionTypes.EDIT_LOAD_BALANCER_ALLOCATION_COMPLETED:
      return {
        ...state,
        editLoadBalancerAllocationLoading: false,
        editLoadBalancerAllocationLoaded: true,
      };
    case ActionTypes.DELETE_LOAD_BALANCER_ALLOCATIONS:
      return {
        ...state,
        deleteLoadBalancerAllocationsLoading: true,
        deleteLoadBalancerAllocationsLoaded: false,
      };
    case ActionTypes.DELETE_LOAD_BALANCER_ALLOCATIONS_COMPLETED:
      return {
        ...state,
        deleteLoadBalancerAllocationsLoading: false,
        deleteLoadBalancerAllocationsLoaded: true,
      };
    case ActionTypes.CHANNELS_DATA_LOADING:
      return {
        ...state,
        channelsDataLoading: true,
        channelsDataLoaded: false,
      };
    case ActionTypes.CHANNELS_DATA_COMPLETED:
      return {
        ...state,
        channelsData: action.payload,
        channelsDataLoading: false,
        channelsDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
